import "core-js/stable";
import "regenerator-runtime/runtime";
import settings from "./settings";
import { createHtmlNode, setAttr } from "./helpers";
const images = require("./images/*.svg");

const DEFAULT_MATCH = "wieni";
const HOST_NAME = window.location.hostname;

let site =
  settings.sites.find(site =>
    HOST_NAME.includes(site.match)
  ) || settings.sites.find(defaultSite => defaultSite.match === DEFAULT_MATCH);

const urlParams = new URLSearchParams(window.location.search);
if (urlParams && urlParams.has("site")) {
  site = settings.sites.find(site => site.match === urlParams.get("site"));
}

if (!site.message || !site.linkMessage) {
  site = {
    ...settings.fallback,
    ...site
  };
}

document.querySelector("body").style.backgroundColor = site.color;

setAttr(document.querySelector(".logo"), {
  src: images[site.match],
  alt: site.match
});

if (site.message) {
  createHtmlNode(".error", "p", ["error__msg"], site.message);
  createHtmlNode(".error", "a", ["error__btn"], site.linkMessage, {
    href: site.link
  });
}

if (site.textColor) {
  document.querySelector("body").style.color = site.textColor;
  document.querySelector("a").style.color = site.textColor;
}
